"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isError = void 0;
exports.isError = (value) => value instanceof Error;
//# sourceMappingURL=is-error.js.map